/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the RptSalPlannedTotaleMeseDto interface.
 */
export function instanceOfRptSalPlannedTotaleMeseDto(value) {
    return true;
}
export function RptSalPlannedTotaleMeseDtoFromJSON(json) {
    return RptSalPlannedTotaleMeseDtoFromJSONTyped(json, false);
}
export function RptSalPlannedTotaleMeseDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'mese': json['mese'] == null ? undefined : json['mese'],
        'anno': json['anno'] == null ? undefined : json['anno'],
        'totaleSal': json['totaleSal'] == null ? undefined : json['totaleSal'],
    };
}
export function RptSalPlannedTotaleMeseDtoToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'mese': value['mese'],
        'anno': value['anno'],
        'totaleSal': value['totaleSal'],
    };
}
